import React from 'react';

export default function About() {
  return (
    <div className="container mx-auto px-4 pt-24 pb-12 text-gray-800">
      <h1 className="text-4xl font-bold mb-8 text-center text-brand-secondary">About Market Bloom</h1>
      
      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-3 text-brand-primary">Our Mission</h2>
        <p className="text-lg leading-relaxed">
          At Market Bloom, our mission is to cultivate joy and connection through the beauty of flowers. We aim to be Australia's most trusted online flower marketplace, making it simple for customers to discover and send stunning, fresh arrangements from the best local florists, while empowering those florists to thrive in the digital age.
        </p>
      </section>

      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-3 text-brand-primary">Who We Are</h2>
        <p className="text-lg leading-relaxed mb-4">
          Market Bloom was born from a passion for flowers and a desire to support local artisans. We are a dedicated team committed to bridging the gap between talented local florists and customers seeking unique, high-quality floral designs. We believe in the power of local businesses to enrich our communities and provide a personal touch that large-scale operations often miss.
        </p>
        <p className="text-lg leading-relaxed">
          Our platform offers a curated selection of florists, each with their own distinct style and expertise, ensuring you can find the perfect flowers for any occasion, from vibrant birthday bouquets to elegant sympathy arrangements.
        </p>
      </section>

      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-3 text-brand-primary">What We Offer</h2>
        <ul className="list-disc list-inside text-lg leading-relaxed space-y-2">
          <li><strong>For Customers:</strong> A seamless and inspiring way to order fresh, beautiful flowers from local artisans, with convenient delivery options and the satisfaction of supporting small businesses.</li>
          <li><strong>For Florists:</strong> A powerful platform to showcase their creativity, reach a wider audience, and streamline their online operations, allowing them to focus on what they do best – crafting exceptional floral arrangements.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-3 text-brand-primary">Our Commitment</h2>
        <p className="text-lg leading-relaxed">
          We are committed to quality, transparency, and community. This means ensuring every bouquet is crafted with care using the freshest blooms, providing clear information about pricing and delivery, and fostering a supportive network for our partner florists. Thank you for choosing Market Bloom – where every order blooms with local love.
        </p>
      </section>
    </div>
  );
} 